import { useEffect, useState } from 'react';
import api from '../../api';

// The backend (/gateways) now returns a paginated page already enriched with
// customer/facility info, so the hook is a single call per page — no per-gateway
// device lookups. `params` carries limit/offset/search/status/sort/order.
// Bump `reloadToken` to refetch the current page (e.g. after deleting a gateway).
const useHttpGetRetailerGateways = (params = {}, reloadToken = 0) => {
    const [gateways, setGateways] = useState([]);
    const [total, setTotal] = useState(0);
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(false);

    const key = JSON.stringify(params);

    useEffect(() => {
        let active = true;

        const load = async () => {
            setIsReady(false);
            setError(false);
            try {
                const res = await api.get_retailer_gateways(params);
                if (!active) {
                    return;
                }
                setGateways(res.data || []);
                setTotal(res.pagination?.total_items || 0);
            } catch (err) {
                if (active) {
                    setError(true);
                    setGateways([]);
                    setTotal(0);
                }
            } finally {
                if (active) {
                    setIsReady(true);
                }
            }
        };

        load();
        return () => {
            active = false;
        };
        // params is captured via the serialized key
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, reloadToken]);

    return { gateways, total, isReady, error };
};

export default useHttpGetRetailerGateways;
